import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { blackListApi } from '../api/black-list.api';
import type {
  IBlackListItem,
  IGetBlackListParams
} from '../pages/BlackList/types/black-list.types';

export const getBlackList = createAsyncThunk(
  'admin/blackList/getBlackList',
  async (params: IGetBlackListParams) => {
    return await blackListApi.getBlackList(params);
  }
);

type TAdminBlackListSlice = {
  blackList: IBlackListItem[];
  total: number;
};

const initialState: TAdminBlackListSlice = {
  blackList: [],
  total: 0
};

const adminBlackListSlice = createSlice({
  name: 'admin/blackList',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBlackList.fulfilled, (state, action) => {
      state.blackList = action.payload.data;
      state.total = action.payload.total;
    });
  }
});

export default adminBlackListSlice;
